// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 649 ? "regulatory" : chunkId) + "." + {"649":"3940db2a","688":"284a81dd","972":"5e752324"}[chunkId] + ".chunk.css";
};